<template>
    <b-card class="m-3" no-body>
        <template #header>
            <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
                Turmas Multiseriadas
            </h6>
        </template>
        <b-form v-if="!loading" class="m-2" @submit.stop.prevent="gerarRelatorio">
            <b-row>
                <b-col cols="12" xl="2">
                    <b-form-group id="input-group-exercicio" label="Exercício *" label-for="input-exercicio" label-class="text-left">
                        <b-form-select :disabled="desabilitarTMS" id="input-exercicio" v-model="filtros.exercicio" :options="exercicios" @change="preparaTMS"/>
                    </b-form-group>
                </b-col>
                <b-col cols="12" xl="2">
                    <b-form-group id="input-group-mes" label="Mês Referência *" label-for="input-mes" label-class="text-left">
                        <b-form-select :disabled="desabilitarTMS || desabilitarMes" id="input-mes" v-model="filtros.mes" :options="meses"/>
                    </b-form-group>
                </b-col>
                <b-col cols="12" xl="3">
                    <b-form-group id="input-group-modalidade" label="Modalidade *" label-for="input-modalidade" label-class="text-left">
                        <b-form-select :disabled="desabilitarTMS" id="input-modalidade" v-model="filtros.modalidade" :options="modalidades"/>
                    </b-form-group>
                </b-col>
                <b-col cols="12" xl="5" class="d-flex align-items-center justify-content-end">
                    <b-button v-if="!loading" 
                    :disabled="desabilitarTMS || !filtros.mes || !filtros.exercicio || !filtros.modalidade" 
                    class="mr-2" size="md" variant="secondary" type="submit">
                        <font-awesome-icon icon="file-alt" class="mr-2" />
                        Gerar Relatório
                    </b-button>
                </b-col>
            </b-row>
        </b-form>
        <div v-if="loading" class="text-center">
            <b-spinner label="Carregando..."></b-spinner>
        </div>
        
        <pdf-viewer v-if="!loading && pdfData" :data="pdfData" :filename="filename" />

    </b-card>
</template>

<script lang="ts">
import { UtilsTS } from '@/utilsts'
import { mixins } from 'vue-class-component'
import { SelectValue } from '@/types/select-value'
import PdfViewer from "@/components/PdfViewer.vue"
import reportService from '@/services/reportService'
import { Component, Vue } from 'vue-property-decorator'
import { FiltrosGestao } from '@/types/relatorios/filtros-gestao'

const CompProps = Vue.extend({
    name: 'TurmasMultiseriadas',
    components: { PdfViewer },
})

@Component
export default class TurmasMultiseriadas extends mixins(UtilsTS, CompProps) {
    pdfData: any = ''
    exercicios: string[] = []
    loading = false
    filtros: FiltrosGestao = new FiltrosGestao()
    meses: SelectValue[] = []
    modalidades: SelectValue[] = []
    filename: string | null = null
    desabilitarTMS = false
    desabilitarMes = false

    async mounted() {
        this.loading = true
        this.meses = this.getListaMeses()
        await this.preparaTMS()
        this.loading = false
    }

    async preparaTMS(ano = null): Promise<any>{
        try {
            this.loading = true
            const response = await reportService.prepararTMS(ano)
            const {desabilitarTMS, exercicios, ultimoMes, msg, modalidades} = response
            if (desabilitarTMS) {
                this.desabilitarTMS = desabilitarTMS
                this.filtros.mes = 0
            }
            if (exercicios) this.exercicios = exercicios
            if (msg) this.$toast.error(msg)
            if (ultimoMes && this.filtros.exercicio) {
                this.desabilitarMes = false
                this.meses = this.meses.filter(m => m.value !== null && Number(m.value) <= ultimoMes)
                this.filtros.mes = Number(this.meses[0].value) ?? 0
            } else this.desabilitarMes = true
            if (modalidades) this.modalidades = modalidades.map((m: any)=>({value: String(m.IdModalidade), text: m.Descricao}))
        } catch (e: any) {
            this.tratarError(e)
        } finally {
            this.loading = false
        }
    }

    async gerarRelatorio(): Promise<void> {
        try {
            this.loading = true; 
            if (this.desabilitarTMS || !this.filtros.mes || !this.filtros.exercicio || !this.filtros.modalidade) {
                this.$toast.error("Relatório indisponível no momento.");
                return;
            }
            this.pdfData = null;
            const ftr = new FiltrosGestao()
            ftr.exercicio = this.filtros.exercicio
            ftr.mes = this.filtros.mes
            ftr.modalidade = this.filtros.modalidade
            const response = await reportService.getRelatorioGestao('EducacaoTurmasMultiseriadas', ftr)
            this.filename = "EducacaoTurmasMultiseriadas_" + this.filtros.exercicio + "_" + this.filtros.mes + "_" + this.filtros.modalidade;
            const blob = this.base64ToPdf(String(response?.ArquivoPdf))
            const objectUrl = URL.createObjectURL(blob)
            this.pdfData = objectUrl;
        } catch (e: any) {
            this.tratarError(e)
        } finally {
            this.loading = false;
        }
    }

    validarFiltros(): boolean {
        if (!this.filtros.exercicio) {
            this.$toast.error('Exercício é obrigatório')
            return false
        }
        if (!this.filtros.mes) {
            this.$toast.error('Mês é obrigatório')
            return false
        }
        if (!this.filtros.modalidade) {
            this.$toast.error('Modalidade é obrigatória')
            return false
        }
        return true
    }

}
</script>